module.exports = __webpack_public_path__ + "static/icons/icon-heart--red-0e1906813c67763194e679a24bfc5883.svg";